import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'App',
    component: () => import('../App.vue'),
    children:[
      {
        path: '/',
        name: 'Home',
        component: () => import('../components/Home.vue'),
      },
    ]
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router;
